import api from '@/modules/auth/api';
import authApi from '@/modules/auth/api/auth';

let refreshTimer = null;

function scheduleRefresh(dispatch, expiresIn) {
  clearTimeout(refreshTimer);
  if (!expiresIn || expiresIn <= 0) return;
  // Обновляем за 60 секунд до истечения (минимум 10 сек)
  const delayMs = Math.max(expiresIn - 60, 10) * 1000;
  refreshTimer = setTimeout(() => {
    dispatch('refreshToken').catch(() => {});
  }, delayMs);
}

export default {
  namespaced: true,
  state: {
    accessToken: null,
    profile: null,
    isInitialized: false,
    initPromise: null,
  },

  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    clearAuth(state) {
      clearTimeout(refreshTimer);
      refreshTimer = null;
      state.accessToken = null;
      state.profile = null;
      localStorage.removeItem('userProfileData');
    },
    setProfile(state, profile) {
      state.profile = profile;
      if (profile) {
        localStorage.setItem('userProfileData', JSON.stringify(profile));
      } else {
        localStorage.removeItem('userProfileData');
      }
    },
    setShowFilters(state, val) {
      if (state.profile) state.profile.showFilters = val;
    },
    setInitialized(state) {
      state.isInitialized = true;
    },
    setInitPromise(state, promise) {
      state.initPromise = promise;
    },
  },

  actions: {
    initialize({ commit, state, dispatch }) {
      if (state.initPromise) return state.initPromise;

      const promise = (async () => {
        try {
          // Если мы на /auth/callback — пропускаем refresh, Callback.vue сам сделает exchange
          if (window.location.hash.startsWith('#/auth/callback')) return;

          const res = await authApi.refresh();
          commit('setAccessToken', res.data.accessToken);
          scheduleRefresh(dispatch, res.data.expiresIn);
          await dispatch('loadProfile');
        } catch {
          commit('clearAuth');
        } finally {
          commit('setInitialized');
          commit('setInitPromise', null);
        }
      })();

      commit('setInitPromise', promise);
      return promise;
    },

    async exchangeCode({ commit, dispatch }, { clientId, code, codeVerifier, redirectUri }) {
      const res = await authApi.exchange({ clientId, code, codeVerifier, redirectUri });
      commit('setAccessToken', res.data.accessToken);
      commit('setInitialized');
      scheduleRefresh(dispatch, res.data.expiresIn);
      await dispatch('loadProfile');
    },

    async refreshToken({ commit, dispatch }) {
      const res = await authApi.refresh();
      commit('setAccessToken', res.data.accessToken);
      scheduleRefresh(dispatch, res.data.expiresIn);
      await dispatch('loadProfile');
      return res.data.accessToken;
    },

    async loadProfile({ commit }) {
      const res = await api.getProfileData();
      commit('setProfile', res.data);
    },

    logout({ commit }) {
      commit('clearAuth');
    },

    loadUser({ dispatch, state }) {
      if (state.isInitialized) return Promise.resolve();
      return dispatch('initialize');
    },
  },

  getters: {
    isAuthenticated: (state) => !!state.accessToken,
    getUserProfile: (state) => state.profile,
    getAccessToken: (state) => state.accessToken,
  },
};
